module.exports = __webpack_public_path__ + "static/img/img-gx.a0b8a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-gx.png
// module id = Fjrj
// module chunks = 0